// Name on Homepage

export function Title({ title }) {
  return (
    <div className="intro-name">
      <h1 className="buyan">{title}</h1>
    </div>
  );
}
